import React from "react";
import "./Breadcrumb.css";
import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => (
  
  <nav className="breadcrumb-nav" aria-label="breadcrumb">
    <ol className="breadcrumb-list">
      {items.map((item, idx) => (
        <li key={item.label} className="breadcrumb-item">
          {item.href ? (
            <Link to={item.href}>{item.label}</Link>
          ) : (
            <span>{item.label}</span>
          )}
          {idx < items.length - 1 && (
            <span className="breadcrumb-separator">›</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumb;